module.exports = __webpack_public_path__ + "static/media/pluxee.d6844017.png";